const { v4: uuidv4 } = require("uuid");
import store from "@/store";

// 模数计算
export const calculateModuloLength = (length, modulus) => {
  if (modulus <= 0) {
    throw new Error("Modulus must be greater than 0");
  }
  let originalLength = Number(length);
  const remainder = originalLength % modulus;
  const roundUp = remainder > modulus / 2;
  if (roundUp) {
    return originalLength + (modulus - remainder);
  } else {
    return originalLength - remainder;
  }
};

// 生成guid
export const generate_guid = () => {
  let guid = uuidv4();
  //大写字母转小写
  guid = guid.toLowerCase();
  return guid;
};

// 修正正交模式
export const fixOrthogonal = (val) => {
  const isOrthogonal = store.state.platBtns.isOrthogonal;
  if (isOrthogonal && window.rlAppObj && window.rlAppObj.mxcadObject) {
    window.rlAppObj.mxcadObject.setSysVarLong("ORTHOMODE", val);
  }
};

/** 取最近点 */
export function getClosestPoint(comparisonPoint, p1, p2) {
  return comparisonPoint.distanceTo(p1) < comparisonPoint.distanceTo(p2)
    ? p1
    : p2;
}
